import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { TagDesktop as Tag } from '@alfa-bank/site-tag/desktop';
import { Img } from '@alfa-bank/site-img';

import type { ITagsHeaderDeps, TTagsHeader } from './models';
import { TagsHeader as Component } from './tags-header';
import styles from './styles/styles.css';

export const TagsHeaderDesktop = createWidget<ITagsHeaderDeps, TTagsHeader>({
    Img,
    Tag,
    styles,
})(Component);
